/**
 * Footer Marquee Smooth Pause with GSAP
 * Gestisce l'animazione del marquee nel footer con easing smooth all'hover usando GSAP
 */

import gsap from 'gsap';

export function initFooterMarquee() {
  const footer = document.querySelector('#site-footer');
  const marqueeLinks = document.querySelectorAll('.marquee-link');
  
  if (!marqueeLinks.length) return;

  marqueeLinks.forEach(link => {
    const marqueeContent = link.querySelector('.marquee-content');
    if (!marqueeContent) return;

    // Disabilita l'animazione CSS
    marqueeContent.style.animation = 'none';

    // Calcola la larghezza per l'animazione
    const contentWidth = marqueeContent.offsetWidth / 2; // Diviso 2 perché il contenuto è duplicato

    // Crea l'animazione GSAP infinita
    const animation = gsap.to(marqueeContent, {
      x: -contentWidth,
      duration: 40,
      ease: 'none',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize(x => parseFloat(x) % contentWidth)
      }
    });

    let hoverTween = null;

    // Gestione hover con easing smooth
    link.addEventListener('mouseenter', () => {
      if (hoverTween) {
        hoverTween.kill();
      }
      // Rallenta l'animazione in modo smooth
      hoverTween = gsap.to(animation, {
        timeScale: 0.1, // Rallenta al 10% della velocità
        duration: 1.2,
        ease: 'power2.out',
        onComplete: () => {
          hoverTween = null;
        }
      });
      
      if(footer.classList.contains('footer-group')){
        gsap.to(marqueeContent.querySelectorAll('span'), {
          opacity: 1,
          duration: 0.4,
          ease: 'power2.out',
          webkitTextFillColor: '#bca281',
        });
      }else{
        gsap.to(marqueeContent.querySelectorAll('span'), {
          opacity: 1,
          duration: 0.4,
          ease: 'power2.out',
          webkitTextFillColor: '#83684B',
        });
      }
    });

    link.addEventListener('mouseleave', () => {
      if (hoverTween) {
        hoverTween.kill();
      }
      // Riporta l'animazione alla velocità normale
      hoverTween = gsap.to(animation, {
        timeScale: 1,
        duration: 0.8,
        ease: 'power2.out',
        onComplete: () => {
          hoverTween = null;
        }
      });
      
      // Ripristina opacità
      gsap.to(marqueeContent.querySelectorAll('span'), {
        opacity: 1,
        duration: 0.4,
        webkitTextFillColor: '',
        ease: 'power2.out'
      });
    });
  });

  //console.log('✨ Footer Marquee GSAP inizializzato -', marqueeLinks.length, 'marquee trovati');
}